export const environment = {
  production: false,
  version: "1.7.0",
  environment: "QA",
  businessId: '180-fitness-dev',
  // cognitoUserPoolId: "us-west-2_d5l6HkhpK",
  // cognitoAppClientId: "7hnm613u80qcue43q4g8ouo8j",
  placeId: "9999",
  empresaBaseId: "180fitnessbsd@gmail.com",
  BASE_URL: "https://xuii0f6g08.execute-api.us-west-2.amazonaws.com/prod",
  BASE_URL_FILES: "https://vf94bs16l0.execute-api.us-west-2.amazonaws.com/prod",
  COGNITO_URL: "https://9cn9x50voa.execute-api.us-west-2.amazonaws.com/prod",
  cognito: {
    /*** RH ***/
    //userPoolWebClientId: "7hnm613u80qcue43q4g8ouo8j",
    //userPoolId: "us-west-2_d5l6HkhpK",
    /*** 180 ***/
    userPoolWebClientId: "66ri7ffbhf6d21glpuglg8b12h",
    userPoolId: "us-west-2_eRNS7S9PK",
  },
};
